import { useState, useEffect } from 'react';

const useOrientationAngle = (): number => {
    const [angle, setAngle] = useState<number>(
        window.screen?.orientation?.angle ?? Number(window.orientation),
    );

    useEffect(() => {
        const listener = (): void => {
            setAngle(window.screen?.orientation?.angle ?? Number(window.orientation));
        };

        window.addEventListener('orientationchange', listener);

        return () => {
            window.removeEventListener('orientationchange', listener);
        };
    }, []);

    return angle;
};

export default useOrientationAngle;
